// extracted by mini-css-extract-plugin
export default {"select":"style_select__4cGDB","sorting":"style_sorting__BVB5R"};